import axios from 'axios';
import * as logger from 'loglevel';
import { isSSR } from '@front10/utils';
import useQueryBuilder from './useQueryBuilder';
import { annotateAndLogError } from '../../../../../helpers/error';
/**
 * Open url in browser for deeplink, if endpoint method is GET or POST
 */
const redirect = ({ url, params, method }) => {
  if (isSSR()) {
    return;
  }
  if (method && method.toLocaleLowerCase() === 'post') {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('target', '_top');
    form.setAttribute('action', url);

    Object.keys(params).forEach((key) => {
      const hiddenField = document.createElement('input');
      hiddenField.setAttribute('type', 'hidden');
      hiddenField.setAttribute('name', key);
      hiddenField.setAttribute('value', params[key]);

      form.appendChild(hiddenField);
    });

    document.body.appendChild(form);
    form.submit();
  } else {
    window.open(url, '_top');
  }
};

export default (container, fare, origin, destination) => {
  const query = useQueryBuilder(container, fare, origin, destination);
  const { v2DeepLinkApiSettings } = container.integrationSettings;
  let error = '';
  if (!v2DeepLinkApiSettings.method) {
    error += 'INTEGRATION__DEEPLINK: **method** is not defined. ';
  }
  if (!v2DeepLinkApiSettings.endPoint) {
    error += 'INTEGRATION__DEEPLINK: **endPoint** is not defined.';
  }
  if (!v2DeepLinkApiSettings.headers) {
    v2DeepLinkApiSettings.headers = {};
  }
  if (error) {
    logger.error(error);
  } else {
    axios({
      method: v2DeepLinkApiSettings.method,
      url: `${v2DeepLinkApiSettings.endPoint}`,
      headers: { ...v2DeepLinkApiSettings.headers },
      data: query
    })
      .then((response) => redirect(response.data))
      .catch((err) => {
        logger.error(
          annotateAndLogError(
            err,
            'INTEGRATION__DEEPLINK',
            false,
            false,
            container.integrationSettings,
            container.meta
          )
        );
      });
  }
};
